import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Sprout } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

const fmt = (n) => (n % 1 === 0 ? n : n.toFixed(1));

const SeedWalletBadge = ({ user }) => {
  const [me, setMe] = useState(null);
  const [flash, setFlash] = useState(false);
  const prev = useRef(null);
  useEffect(() => {
    if (!user) { setMe(null); prev.current = null; return; }
    let on = true;
    const load = () => api.get("/seeding/me").then((r) => {
      if (!on) return;
      const d = r.data;
      setMe(d);
      if (d?.linked) {
        const t = Number(d.tickets ?? d.seeds_balance ?? 0);
        const dy = Number(d.days_balance ?? 0);
        const p = prev.current;
        if (p) {
          const dt = t - p.t, dd = dy - p.d;
          if (dt > 0.001 || dd > 0.001) {
            setFlash(true);
            setTimeout(() => { if (on) setFlash(false); }, 2600);
            const parts = [];
            if (dt > 0.001) parts.push(`+${fmt(dt)} tickets`);
            if (dd > 0.001) parts.push(`+${fmt(dd)} whitelist day${dd === 1 ? "" : "s"}`);
            toast.success(`Seed reward! ${parts.join(" \u00b7 ")}`, { description: "Thanks for seeding \u2014 ocedogs.com/seeding" });
          }
        }
        prev.current = { t, d: dy };
      }
    }).catch(() => {});
    load();
    const id = setInterval(load, 25000); // live-update tickets / whitelist days site-wide
    return () => { on = false; clearInterval(id); };
  }, [user]);

  if (!user) return null;

  const linked = me?.linked;
  const days = linked ? Number(me.days_balance || 0) : 0;
  const tickets = linked ? Number(me.tickets ?? me.seeds_balance ?? 0) : 0;

  return (
    <Link
      to="/seeding"
      data-testid="seed-wallet-badge"
      title={linked ? `${fmt(tickets)} Seed tickets · ${fmt(days)} whitelist day(s) · Level ${me.level} ${me.rank_name}` : "Seed Levels — connect Steam to start earning"}
      className={`hidden sm:inline-flex items-center gap-1.5 h-9 px-2.5 bg-[#13151B]/80 border tactical-frame-sm transition-[border-color,box-shadow] duration-500 group ${flash ? "border-[#2ECC71] shadow-[0_0_20px_rgba(46,204,113,0.75)]" : "border-[#2A2E3D] hover:border-[#2ECC71]/70"}`}
    >
      <Sprout className={`w-4 h-4 text-[#2ECC71] transition-transform duration-300 group-hover:scale-110 ${flash ? "scale-125" : ""}`} />
      {linked ? (
        <span className="flex items-baseline gap-1 leading-none">
          <span className="font-mono font-bold text-xs text-[#D4A94A]" data-testid="seed-wallet-tickets">{fmt(tickets)}</span>
          <span className="font-mono text-[9px] text-[#64748B] uppercase">tix</span>
          <span className="font-mono text-[9px] text-[#2ECC71] ml-1" data-testid="seed-wallet-days">{fmt(days)}d · L{me.level}</span>
        </span>
      ) : (
        <span className="font-mono text-[10px] uppercase tracking-wide text-[#64748B]">Seed</span>
      )}
    </Link>
  );
};

export default SeedWalletBadge;
